import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'module-tsl-ui-elements';

function buildPageArray(start, end) {
  var pages = [];

  for (var i = start; i <= end; i += 1) {
    // eslint-disable-line no-plusplus
    pages.push(i);
  }

  return pages;
}

function Pagination(_ref) {
  var currentPage = _ref.currentPage,
      numberOfPages = _ref.numberOfPages,
      numberOfLinks = _ref.numberOfLinks,
      getLinkFromPage = _ref.getLinkFromPage,
      onChangePage = _ref.onChangePage;

  var manageClick = function manageClick(n) {
    return function (e) {
      e.preventDefault();
      onChangePage(n, e);
    };
  };

  if (numberOfPages <= 1) {
    return /*#__PURE__*/React.createElement("div", null);
  }

  var startNumber = currentPage - Math.floor(numberOfLinks / 2);
  var endNumber = currentPage + Math.ceil(numberOfLinks / 2);

  if (startNumber < 1) {
    endNumber += Math.abs(startNumber);
    startNumber = 1;
  }

  if (endNumber > numberOfPages) {
    endNumber = numberOfPages;
  }

  var pages = buildPageArray(startNumber, endNumber);
  var shouldIncludeFirst = startNumber !== 1;
  var shouldIncludeFirstWithEllipsis = shouldIncludeFirst && startNumber !== 2;
  var shouldIncludeLast = endNumber !== numberOfPages;
  var shouldIncludeLastWithEllipsis = shouldIncludeLast && endNumber !== numberOfPages - 1;
  return /*#__PURE__*/React.createElement("nav", {
    className: "pagination",
    "aria-label": "Pagination navigation"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "pagination__items"
  }, currentPage !== 1 && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Button, {
    className: "pagination__prev",
    icon: "tds-chevron-left",
    iconOnly: true,
    theme: "tertiary",
    href: getLinkFromPage(currentPage - 1),
    onClick: manageClick(currentPage - 1)
  }, "Previous page")), shouldIncludeFirst && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Button, {
    theme: "tertiary",
    href: getLinkFromPage(1),
    onClick: manageClick(1),
    "aria-label": "Page 1"
  }, "1")), shouldIncludeFirstWithEllipsis && /*#__PURE__*/React.createElement("i", {
    className: "icon icon-dots icon--unit-md"
  }), pages.map(function (n) {
    return /*#__PURE__*/React.createElement("li", {
      key: n
    }, n === currentPage ? /*#__PURE__*/React.createElement(Button, {
      type: "button",
      "aria-current": "page",
      "aria-label": "Page ".concat(n)
    }, n) : /*#__PURE__*/React.createElement(Button, {
      theme: "tertiary",
      href: getLinkFromPage(n),
      onClick: manageClick(n),
      "aria-label": "Page ".concat(n)
    }, n));
  }), shouldIncludeLastWithEllipsis && /*#__PURE__*/React.createElement("i", {
    className: "icon icon-dots icon--unit-md"
  }), shouldIncludeLast && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Button, {
    theme: "tertiary",
    href: getLinkFromPage(numberOfPages),
    onClick: manageClick(numberOfPages),
    "aria-label": "Last page, ".concat(numberOfPages)
  }, numberOfPages)), currentPage !== numberOfPages && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Button, {
    className: "pagination__next",
    theme: "tertiary",
    icon: "tds-chevron-right",
    iconOnly: true,
    href: getLinkFromPage(currentPage + 1),
    onClick: manageClick(currentPage + 1)
  }, "Next page"))));
}

Pagination.displayName = "Pagination";
Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  numberOfPages: PropTypes.number.isRequired,
  numberOfLinks: PropTypes.number,
  getLinkFromPage: PropTypes.func,
  onChangePage: PropTypes.func
};
Pagination.defaultProps = {
  getLinkFromPage: function getLinkFromPage(n) {
    return n.toString();
  },
  numberOfLinks: 3,
  onChangePage: function onChangePage() {}
};
export default Pagination;